module.exports = __webpack_public_path__ + "img/evaluation-survey.a1ad836d.png";